export class UnitReq{
    unitId:number
    isActive?:boolean
}